"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const SystemStatusFlash = ({ session }) => {
    if (session.systemInfoMessage) {
        return react_1.default.createElement(polaris_1.Flash, { type: "warning", content: session.systemInfoMessage });
    }
    return null;
};
exports.default = SystemStatusFlash;
//# sourceMappingURL=SystemStatusFlash.js.map